import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import {
  Avatar,
  InputBase,
  Button,
  IconButton,
  Typography,
  TextField,
  MenuItem,
  Tooltip,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import { Announcement, Close, Newspaper } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import PublicIcon from "@mui/icons-material/Public";
import ImageIcon from "@mui/icons-material/Image";
import PhotoSizeSelectActualOutlinedIcon from "@mui/icons-material/PhotoSizeSelectActualOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import { show_proper_words } from "../../utils/Constant";
import {
  add_new_feed,
  update_feed_image_on_s3,
  update_new_feed,
} from "../../DAL/partner/partners";
import { s3baseUri } from "../../config/config";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  csvImage,
  docImage,
  pdfImage,
  wordImage,
  audioImage,
  xlsxImage,
  otherImage,
} from "../../assets";
import { useIds } from "../../hook/AdminContext";
import LinkPreview from "../../components/previewUrl/PreviewsUrl";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 581,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 1,
  borderRadius: 2,
  outline: "none",
};

export default function CreatePost({
  setFeedType,
  feedType,
  openCreateModal,
  userInfo,
  setOpenCreateModal,
  selectedFeed,
  getFeedsListing,
  type,
  previewLink,
  setPreviewLink,
  urlLink,
  setUrlLink,
}) {
  let typeTosend = type;
  const { ids, findId } = useIds();
  const { pathname } = useLocation();
  const [previews, setPreviews] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [forcePreview, setForcePreview] = useState(false);

  const firstSegment = pathname.split("/")[1];
  const [inputs, setInputs] = useState({
    description: "",
    post_type: "resources",
    created_for: "",
    video_url: "",
  });
  const [isFocused, setIsFocused] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const inputRef = useRef(null);
  const handleChange = async (e) => {
    let { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
    if (name === "description") {
      if (value.trim() !== "") {
        setUrlLink(value);
      }
    }

    if (type === "EDIT" && name === "description") {
      const oldUrl = extractURL(selectedFeed?.description || "");
      const newUrl = extractURL(value || "");

      if (newUrl && newUrl !== oldUrl) {
        setPreviewLink(true);
      } else {
        setPreviewLink(false);
      }
    }

    setIsFocused(false);
  };

  const UploadImages = async (formData) => {
    const result = await update_feed_image_on_s3(formData);
    return result.image_path;
  };
  const extractURL = (str) => {
    console.log(str, "strstrstrstrstr");

    // Match http(s) URLs or www. URLs
    const urlRegex = /((https?:\/\/|www\.)[^\s]+)/gi;
    const match = str?.match(urlRegex);

    if (match && match[0]) {
      const url = match[0];
      // Agar url 'www.' se shuru hota hai, prepend 'http://'
      if (url.startsWith("www.")) {
        return "http://" + url;
      }
      return url;
    }
    return null;
  };
  const linkInDescription = extractURL(inputs.description);
  const urlLinkViaPreview = extractURL(urlLink);
  const filteredData = ids?.filter((item) =>
    userInfo.source.some((source) => source.source_id === item._id)
  );
  const imageLinks = {
    docx: wordImage,
    mp3: audioImage,
    pdf: pdfImage,
    csv: csvImage,
    doc: docImage,
    xlsx: xlsxImage,
    xls: xlsxImage,
    other: otherImage,
  };
  let id = findId;
  if (!id) {
    id = localStorage.getItem("source_id");
  }
  console.log(id, "idididididididid");
  const isMobile = useMediaQuery("(max-width:600px)");

  const handlePost = async (e) => {
    e.preventDefault();
    // if (!inputs.video_url && !inputs.description && previews.length < 1) {
    //   enqueueSnackbar(
    //     "At least one type of content must be included in the feed: description, document, video, or image.",
    //     { variant: "error" }
    //   );
    //   return;
    // }

    if (feedType === "image" && previews.length === 0) {
      enqueueSnackbar("please upload image ", { variant: "error" });
      return;
    }

    if (feedType === "video" && !inputs.video_url) {
      enqueueSnackbar("please upload Video ", { variant: "error" });
      return;
    }

    if (feedType === "documnet" && previews.length === 0) {
      enqueueSnackbar("please upload Documnet ", { variant: "error" });
      return;
    }

    let results = previews.map((image, index) => {
      if (image?.type === "file") {
        const formData = new FormData();
        formData.append("image", image.path);
        const result = UploadImages(formData);
        return result;
      } else {
        return image;
      }
    });
    Promise.all(results).then(async (img_results) => {
      const formData = new FormData();
      formData.append(
        "video_url",
        feedType === "video" ? inputs.video_url : ""
      );
      formData.append("is_link_preview", previewLink);
      formData.append("description", inputs.description);
      if (type === "ADD") {
        formData.append(
          "created_for",
          firstSegment !== "home"
            ? localStorage.getItem("source_id")
            : inputs.created_for
        );
        formData.append("post_type", inputs.post_type);
      }
      if (feedType === "image" && previews.length >= 1) {
        formData.append("image", JSON.stringify(img_results));
        formData.append("feed_type", "image");
      } else if (feedType === "document" && previews.length >= 1) {
        formData.append("image", JSON.stringify(img_results));
        formData.append("feed_type", "document");
      } else {
        if (inputs.video_url) {
          formData.append("feed_type", "video");
        } else {
          formData.append("feed_type", "general");
        }
      }
      console.log(...formData, "formdalkdsnkbd");
      setIsLoading(true);
      const result =
        type === "ADD"
          ? await add_new_feed(formData)
          : await update_new_feed(formData, selectedFeed._id);
      if (result.code === 200) {
        setInputs((values) => ({
          ...values,
          description: "",
          post_type: "resources",
          created_for: "",
          video_url: "",
        }));
        getFeedsListing(`api/feed/list?page=0&limit=50`);
        setPreviews([]);
        setIsLoading(false);
        handleClose();
        enqueueSnackbar(result.message, { variant: "success" });
      } else {
        setIsLoading(false);
        enqueueSnackbar(result.message, { variant: "error" });
      }
    });
  };

  const handleRemoveImage = (path) => {
    setPreviews((images) => {
      return images.filter((image) => image !== path);
    });
  };

  const getCommentImage = (file) => {
    if (file?.type === "file") {
      const ext = file.path.name.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return URL.createObjectURL(file.path);
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    } else {
      const ext = file.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return s3baseUri + file;
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    }
  };
  const finalDescription =
    inputs.description?.trim() !== "" ? inputs.description : urlLink;
  const handleUpload = async (event) => {
    const fileList = event.target.files;
    const imagesToAdd = [];

    for (let i = 0; i < fileList.length; i++) {
      imagesToAdd.push({
        path: fileList[i],
        type: "file",
      });
    }

    setPreviews((prevFiles) => [...prevFiles, ...imagesToAdd]);
  };

  const handleClose = () => {
    if (type === "ADD") {
      setInputs((values) => ({ ...values, video_url: "" }));
      setInputs((values) => ({ ...values, description: "" }));

      setPreviews([]);
    }
    if (type === "EDIT") {
      setInputs((values) => ({ ...values, video_url: selectedFeed.video_url }));
      setInputs((values) => ({
        ...values,
        description: selectedFeed.description,
      }));
    }
    setOpenCreateModal(false);
  };

  const typeMapping = {
    hospitality: "Hospitality",
    warehouse: "Warehouse_Logistics",
    healthcare: "Healthcare_Source",
    "office-source": "Office_Source",
    "retail-source": "Retail_Source",
    "food-source": "Food_Source",
    "construction-source": "Construction_Source",
    "fit-out-source": "Fit_Out_Source",
  };

  const handleVideoTypeChange = (value) => {
    setFeedType(value);
    setInputs((prevInputs) => ({
      ...prevInputs,
      video_url: "",
    }));
    setPreviews([]);
  };

  useEffect(() => {
    if (type === "EDIT") {
      let find_create = ids.find(
        (item) => item?._id === selectedFeed?.created_for
      );
      setInputs((values) => ({
        ...values,
        video_url: selectedFeed.video_url,
        description: selectedFeed.description,
        post_type: selectedFeed.post_type || "resources",
        created_for: find_create?._id || "",
      }));

      setFeedType(selectedFeed.feed_type);
      setPreviewData(selectedFeed?.is_link_preview);
      if (selectedFeed.image && selectedFeed.image.length > 0) {
        setPreviews(selectedFeed.image);
      }
    } else {
      setInputs({
        video_url: "",
        description: "",
        post_type: "resources",
        created_for: "",
      });
      setFeedType("general");
      setPreviews([]);
    }
  }, [type, ids, selectedFeed]);

  useEffect(() => {
    if (!inputs.created_for && filteredData.length > 0) {
      setInputs((values) => ({
        ...values,
        created_for: filteredData[0]._id,
      }));
    }
  }, [filteredData, inputs.created_for, firstSegment]);

  useEffect(() => {
    if (type === "ADD") {
      setPreviewLink(true);
    }
  }, [type]);
  useEffect(() => {
    if (type === "EDIT") {
      const oldUrl = extractURL(selectedFeed?.description);
      const newUrl = extractURL(inputs.description);
      if (newUrl && newUrl !== oldUrl) {
        setForcePreview(true);
      } else {
        setForcePreview(false);
      }
    }
  }, [inputs.description, type, selectedFeed]);

  return (
    <div className="container-fluid col-12 ">
      <Modal open={openCreateModal}>
        <Box
          sx={{
            ...style,
            width: { xs: "90%", sm: "80%", md: "50%" },
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "5px",
              marginLeft: "9px",
              marginRight: "9px",
            }}
          >
            <h4
              className="groups-text"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              {type === "edit" ? "Update Post" : "Create a Post"}
            </h4>
            <Close
              style={{ cursor: "pointer", color: "gray" }}
              onClick={handleClose}
            />
          </div>
          <div className="create-post-content">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <Avatar src={s3baseUri + userInfo?.profile_image} />
              <Box ml={2}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  className="mui-typo-heading"
                >
                  {userInfo?.company_name}
                </Typography>
                {type == "ADD" && (
                  <Box display="flex" alignItems="center" gap={2} width="100%">
                    {/* <TextField
                      select
                      size="small"
                      variant="outlined"
                      label="Type"
                      name="post_type"
                      value={inputs.post_type || "resources"}
                      onChange={handleChange}
                      inputRef={inputRef}
                      sx={{
                        marginTop: "8px",
                        maxWidth: isMobile ? 131 : 134,
                        "& .MuiInputLabel-root": {
                          fontSize: "14px",
                        },

                        "& .MuiOutlinedInput-root": {
                          borderRadius: "5px",
                          height: 30,
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          borderColor: isFocused ? "#000080" : "#ccc",
                        },
                        "& .MuiInputBase-root": {
                          minHeight: "30px",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiSelect-select": {
                          padding: "4px 8px",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiOutlinedInput-root.Mui-focused": {
                          borderColor: "#000080",
                        },
                      }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    >
                      <MenuItem
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        value="resources"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <PublicIcon sx={{ fontSize: 14, color: "#daa520" }} />
                        <span className="span-post">Resources</span>
                      </MenuItem>
                      <MenuItem
                        value="annoucement"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <Announcement sx={{ fontSize: 14, color: "#daa520" }} />
                        <span className="span-post">Announcement</span>
                      </MenuItem>
                      <MenuItem
                        value="news"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <Newspaper sx={{ fontSize: 14, color: "#daa520" }} />
                        <span className="span-post">News</span>
                      </MenuItem>
                      <MenuItem
                        value="general"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <ImageIcon sx={{ fontSize: 14, color: "#daa520" }} />
                        <span className="span-post">General feed</span>
                      </MenuItem>
                    </TextField> */}
                    {pathname === "/home" && type === "ADD" ? (
                      <Box sx={{ flexGrow: 1, minWidth: 200 }}>
                        <TextField
                          size="small"
                          fullWidth
                          variant="outlined"
                          select
                          label="Select page for post"
                          name="created_for"
                          value={inputs.created_for || ""}
                          onChange={handleChange}
                          sx={{
                            marginTop: "8px",
                            maxWidth: isMobile ? 120 : 175,
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "5px",
                              height: 32,
                              fontSize: "13px",
                              padding: "4px",
                              display: "flex",
                              alignItems: "center",
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: "13px",
                            },
                          }}
                        >
                          {filteredData && filteredData.length > 0 ? (
                            filteredData.map((option, index) => (
                              <MenuItem key={index} value={option._id}>
                                {show_proper_words(option.title)}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>No options available</MenuItem>
                          )}
                        </TextField>
                      </Box>
                    ) : (
                      ""
                    )}
                  </Box>
                )}
              </Box>
            </div>

            <InputBase
              fullWidth
              placeholder="What do you want to talk about..."
              value={inputs.description}
              onChange={handleChange}
              name="description"
              multiline
              rows={4}
              style={{ marginBottom: 10 }}
            />
            <div className="col-12 mb-3">
              {feedType == "video" && (
                <div className="col-12 mt-3 video-url-field">
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Video URL"
                    size="small"
                    name="video_url"
                    required
                    value={inputs.video_url}
                    type="url"
                    onChange={handleChange}
                    placeholder="Video URL"
                  />
                  <span
                    className="video-url-cross"
                    onClick={() => {
                      setInputs((values) => ({ ...values, video_url: "" }));
                      setPreviewLink(true);
                      setFeedType("general");
                    }}
                  >
                    x
                  </span>
                </div>
              )}
              {linkInDescription && (
                <LinkPreview
                  setInputs={setInputs}
                  text={linkInDescription}
                  previewLink={previewLink}
                  setPreviewLink={setPreviewLink}
                  type={"icon_show"}
                  previewData={previewData}
                  setPreviewData={setPreviewData}
                  selectedFeed={selectedFeed}
                  typeData={typeTosend}
                  forcePreview={forcePreview}
                />
              )}

              {feedType === "image" || feedType === "document" ? (
                <div className="col-12 mt-2">
                  <div className="row justify-content-center">
                    {previews.length > 0 &&
                      previews.map((preview) => {
                        if (preview) {
                          return (
                            <span className="col-2 mb-3 preview create-post-images">
                              <span
                                onClick={() => {
                                  handleRemoveImage(preview);
                                }}
                              >
                                x
                              </span>
                              <img
                                className="img-fluid"
                                src={getCommentImage(preview)}
                              />
                            </span>
                          );
                        }
                      })}
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <span className="upload-button mt-2 w-100">
                        <input
                          multiple
                          color="primary"
                          accept={
                            feedType === "image"
                              ? "image/*"
                              : ".pdf, .doc, .docx, .txt"
                          }
                          type="file"
                          id="icon-button-file"
                          style={{ display: "none" }}
                          onChange={handleUpload}
                        />
                        <label htmlFor="icon-button-file">
                          <span
                            onClick={() => {
                              setFeedType("general");
                            }}
                          >
                            x
                          </span>
                          <p className="mt-3">
                            {feedType === "image" ? (
                              <>
                                Add Photo <br />
                                <CloudUploadIcon />
                              </>
                            ) : (
                              <>
                                Add Document <br />
                                <CloudUploadIcon />
                              </>
                            )}
                          </p>
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="my-4 d-flex">
                <Tooltip title="Upload Document">
                  <IconButton
                    className="mui-chip-all"
                    sx={{
                      border: feedType == "document" ? "1px solid #000080" : "",
                    }}
                    onClick={() => {
                      handleVideoTypeChange("document");
                    }}
                  >
                    <TextSnippetOutlinedIcon
                      style={{
                        color: "#F5CE6E",
                      }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Upload Video">
                  <IconButton
                    className="mui-chip-all"
                    sx={{
                      border: feedType == "video" ? "1px solid #000080" : "",
                    }}
                    onClick={() => {
                      handleVideoTypeChange("video");
                    }}
                  >
                    <VideocamOutlinedIcon
                      style={{
                        color: "#F5CE6E",
                      }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Upload Photo">
                  <IconButton
                    className="mui-chip-all"
                    sx={{
                      border: feedType == "image" ? "1px solid #000080" : "",
                    }}
                    onClick={() => {
                      handleVideoTypeChange("image");
                    }}
                  >
                    <PhotoSizeSelectActualOutlinedIcon
                      style={{
                        color: "#F5CE6E",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <Button
              fullWidth
              variant="contained"
              className="contain-button-mui"
              style={{
                backgroundColor: "#000080",
                color: "white",
              }}
              onClick={handlePost}
            >
              {isLoading ? (
                <>
                  <CircularProgress
                    size={14}
                    color="inherit"
                    sx={{ position: "relative", right: "10px" }}
                  />

                  {type === "EDIT" ? "Updating..." : "Posting..."}
                </>
              ) : (
                <>{type === "EDIT" ? " Update" : "Post"}</>
              )}
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
